import { publishes } from '@alphadesk/ontology/objects/analyst.ts';
// The single source for nav links, so no link reaches a page the viewer cannot use.
import { isDesk, type Viewer } from '@alphadesk/web/contract.ts';
import { PAGES } from '@alphadesk/web/links.ts';

export interface PageLink {
  href: string;
  label: string;
}

/** Who may file: the desk, and an approved analyst under their own name. */
export const files = (viewer: Viewer): boolean => isDesk(viewer) || publishes(viewer.analyst);

/** The account is the avatar's, not a nav item. */
export function navFor(viewer: Viewer): PageLink[] {
  const desk = isDesk(viewer);
  return [
    { href: PAGES.home, label: 'Home' },
    { href: PAGES.trades, label: 'Trades' },
    { href: PAGES.analysts, label: 'Analysts' },
    ...(files(viewer) ? [{ href: PAGES.add, label: 'Add' }] : []),
    { href: PAGES.notifications, label: 'Inbox' },
    ...(viewer.memberId !== null ? [{ href: PAGES.investments, label: 'Investments' }] : []),
    ...(viewer.memberId !== null && !desk ? [{ href: PAGES.pnl, label: 'P/L' }] : []),
    { href: PAGES.markets, label: 'Markets' },
    ...(desk ? [{ href: PAGES.desk, label: 'Desk' }] : []),
    { href: PAGES.help, label: 'Help' },
  ];
}

/** `/` is Home alone; every other page lights for its tabs and sections too. */
export const isHere = (path: string, href: string): boolean =>
  href === PAGES.home ? path === href : path === href || path.startsWith(`${href}/`);
